host.actions.register({
    // #region Vars
    name: '288a.system.link.open',
    // #endregion
    // #region Entry
    async execute(data, params) {
        if (!params?.url) {
            return { isSucceeded: false };
        }
        //Run
        this.$host.router.push(params.url);
        //Finish
        return { isSucceeded: false };
    },
    // #endregion
});
export {};
